import { SelectorOption } from '../../RawSelector';

export const BUSINESS_TYPES: SelectorOption[] = [
  { value: 'non_profit', displayName: 'Non Profit', selected: true },
  { value: 'company', displayName: 'Company' },
  { value: 'government_entity', displayName: 'Government Entity' },
];

export const BUSINESS_STRUCTURES: Record<string, SelectorOption[]> = {
  company: [
    {
      value: 'sole_proprietorship',
      displayName: 'Sole Proprietorship',
      selected: true,
    },
    { value: 'single_member_llc', displayName: 'Single Member LLC' },
    { value: 'multi_member_llc', displayName: 'Multi Member LLC' },
    { value: 'private_partnership', displayName: 'Private Partnership' },
    {
      value: 'unincorporated_association',
      displayName: 'Unincorporated Association',
    },
    { value: 'public_partnership', displayName: 'Public Partnership' },
    { value: 'public_corporation', displayName: 'Public Corporation' },
  ],

  non_profit: [
    {
      value: 'incorporated_non_profit',
      displayName: 'Incorporated Non Profit',
      selected: true,
    },
    {
      value: 'unincorporated_non_profit',
      displayName: 'Unincorporated Non Profit',
    },
  ],

  government_entity: [
    {
      value: 'government_instrumentality',
      displayName: 'Government Instrumentality',
      selected: true,
    },
    { value: 'governmental_unit', displayName: 'Governmental Unit' },
    {
      value: 'tax_exempt_government_instrumentality',
      displayName: 'Tax Exempt Government Instrumentality',
    },
  ],
};
